var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:(`width: ${_setup.lineupWidth}px; height: ${_setup.lineupHeight}px`),attrs:{"id":"lineup"},on:{"mouseleave":_setup.removeHighlight}})
}
var staticRenderFns = []

export { render, staticRenderFns }